module.exports = __webpack_public_path__ + "static/media/18wkndhawaii2.1ae6ac9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/18wkndhawaii2.png
// module id = 117
// module chunks = 0